import styled from "styled-components";

export default styled.div`
    .titleRow {
        align-items: center;
    }

    .titleWithScore {
        display: flex;
        align-items: center;
        gap: 12px;
    }

    .scoreBadge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 40px;
        height: 28px;
        padding: 0 10px;
        border-radius: 5px;
        font-size: 14px;
        font-weight: bold;
        color: black;

        &.score-1 {
            background-color: ${(props) => props.theme.bqmqVoteScore5};
        }
        &.score-2 {
            background-color: ${(props) => props.theme.bqmqVoteScore4};
        }
        &.score-3 {
            background-color: ${(props) => props.theme.bqmqVoteScore3};
        }
        &.score-4 {
            background-color: ${(props) => props.theme.bqmqVoteScore2};
        }
        &.score-5 {
            background-color: ${(props) => props.theme.bqmqVoteScore1};
        }
    }

    .versionSelect {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .versionLabel {
            font-size: 11px;
            letter-spacing: 0.08em;
            text-transform: uppercase;
            color: ${(props) => props.theme.tableHeadCellBackground};
            margin-bottom: 4px;
        }

        > div {
            margin: 0;

            p {
                margin: 0;
            }
        }
    }

    .noData {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        width: 100%;
        height: 200px;

        svg {
            font-size: 50px;
            color: ${(props) => props.theme.tableHeadCellBackground};
            margin-bottom: 20px;
        }

        p {
            color: ${(props) => props.theme.tableHeadCellBackground};
            letter-spacing: 0.1em;
            text-align: center;
        }

        .highlight {
            font-weight: 600;
        }
    }

    .separator-row td {
        padding-top: 6px !important;
        padding-bottom: 6px !important;
        border-bottom: none !important;
    }
`;
